import React from "react";

export const CalendarIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="calendar-icon"
    >
      <path
        d="M19.7451 4.39941H5.74512C4.64055 4.39941 3.74512 5.29484 3.74512 6.39941V20.3994C3.74512 21.504 4.64055 22.3994 5.74512 22.3994H19.7451C20.8497 22.3994 21.7451 21.504 21.7451 20.3994V6.39941C21.7451 5.29484 20.8497 4.39941 19.7451 4.39941Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.7451 2.39941V6.39941"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.74512 2.39941V6.39941"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.74512 10.3994H21.7451"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
